module.exports = __webpack_public_path__ + "static/media/flUhRq6tzZclQEJ-Vdg-IuiaDsNcIhQ8tQ.393b5d8b.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/flUhRq6tzZclQEJ-Vdg-IuiaDsNcIhQ8tQ.woff2
// module id = 988
// module chunks = 0